import { type ReactNode } from 'react';

interface BentoGridProps {
  children: ReactNode;
  className?: string;
}

/**
 * Bento grid layout for article cards.
 *
 * Desktop (3-col):  Featured spans 2 cols, rest fill 1-col slots.
 * Tablet (2-col):    Featured spans 2 cols, rest stack in a 2-col row.
 * Mobile (1-col):    All cards stack vertically, featured slightly taller.
 *
 * Usage:
 *   <BentoGrid>
 *     <BentoGrid.Featured>...</BentoGrid.Featured>
 *     <BentoGrid.Cell>...</BentoGrid.Cell>
 *     ...
 *   </BentoGrid>
 */
export function BentoGrid({ children, className = '' }: BentoGridProps) {
  return (
    <div
      className={`
        grid grid-cols-1 gap-4
        sm:grid-cols-2
        lg:grid-cols-3
        ${className}
      `.trim().replace(/\s+/g, ' ')}
    >
      {children}
    </div>
  );
}

function BentoFeatured({ children, className = '' }: BentoGridProps) {
  return (
    <div
      className={`
        sm:col-span-2 lg:col-span-2
        ${className}
      `.trim().replace(/\s+/g, ' ')}
    >
      {children}
    </div>
  );
}

function BentoCell({ children, className = '' }: BentoGridProps) {
  return (
    <div className={className}>
      {children}
    </div>
  );
}

BentoGrid.Featured = BentoFeatured;
BentoGrid.Cell = BentoCell;
